import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { NotebookPen, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { isoToday } from "@/lib/foodlog";

// Carte Tableau de bord → page Journal (la navigation mobile garde ses 4 onglets).
export function JournalCard() {
  const { t } = useLang();
  const date = isoToday();
  const { data } = useQuery({ queryKey: ["food-day", date, "primary"], queryFn: async () => (await api.get("/food/day", { params: { date, member_id: "primary" } })).data });
  return (
    <div className="chenia-card p-5 sm:p-6 flex flex-wrap items-center gap-4" data-testid="dashboard-journal-card">
      <span className="grid place-items-center h-12 w-12 rounded-2xl bg-chenia-rosesoft text-chenia-terracottadark shrink-0"><NotebookPen className="h-6 w-6" /></span>
      <div className="flex-1 min-w-[12rem]">
        <h2 className="font-semibold">{t("j_dash_title")}</h2>
        <p className="text-sm text-muted-foreground" data-testid="dashboard-journal-summary">{data?.count ? `${data.totals.calories} ${t("kcal")} ${t("j_consumed")}${data.target ? ` · ${t("j_remaining")} ${data.remaining} ${t("kcal")}` : ""}` : t("j_dash_sub")}</p>
      </div>
      <Link to="/journal"><Button className="rounded-full bg-primary hover:bg-chenia-terracottadark" data-testid="dashboard-open-journal">{t("j_open")} <ArrowRight className="h-4 w-4 ml-1" /></Button></Link>
    </div>
  );
}
